import * as React from 'react';
import { ComponentProps, ButtonTertiary, ButtonPrimary } from 'ui';
import {  OpenStateInjectedProps } from 'ui/common/enhancers';
import { PrimaryActionComponentProps } from 'app/area/case-report/case-listing/types';
import { nextSequenceValue } from 'app/area/case/features/connected-cases/sequence';
import { columnName, tableName } from 'app/area/case/case-data-model';
import { StoreField } from 'app/types-shared';
import { AddDocumentItemOptions, DeleteDocumentItemOptions } from 'app/infrastructure/ui/form/types';
import { EmbeddedFavouriteButton } from 'app/area/case/components/embedded-favourite-button';

interface CheckForDuplicateRegistrationsButtonProps extends ComponentProps, OpenStateInjectedProps {
  readOnly?: boolean;
  entityId: number;
  connectionTypeId: number;
  maxSequence: number;
  textConnect: string;
  textDisconnect: string;
  textMissingSearchArguments: string;
  textSearchTitle: string;
  reportId: number;
  connectedCasesPendingDeleteIds?: number[];
  connectedCasesIds?: number[];
  requiredSearchFieldsFilled: boolean;
  createSearchForCasesToConnect: (draftId: number, connectionTypeId: number) => Promise<number>;
  onAddDocumentItem: (selectAddedItem: boolean, options: AddDocumentItemOptions) => void;
  onDeleteDocumentItem: (selectParentItem: boolean, options: DeleteDocumentItemOptions) => void;
  favouriteComponent: React.ComponentType<any>;
}

interface CheckForDuplicateRegistrationsButtonState {
  favouriteId?: number;
}

export class CheckForDuplicateRegistrationsButton
  extends React.Component<CheckForDuplicateRegistrationsButtonProps, CheckForDuplicateRegistrationsButtonState> {

  private getNextSequenceValue = () => nextSequenceValue(this.props.maxSequence);

  private renderActionComponent = (props: PrimaryActionComponentProps) => {
    const caseAlreadyConnected = this.props.connectedCasesIds.indexOf(props.caseId) > -1;
    const pendingDelete = this.props.connectedCasesPendingDeleteIds.indexOf(props.caseId) > -1;

    return caseAlreadyConnected ?
      <ButtonTertiary onClick={this.removeConnection(props.caseId)}>{this.props.textDisconnect}</ButtonTertiary> :
      <ButtonPrimary onClick={this.addConnection(props.caseId)} disabled={pendingDelete}>{this.props.textConnect}</ButtonPrimary>;
  }

  private addConnection = (caseIdToConnect: number) => () => {
    const { entityId, onAddDocumentItem, connectionTypeId } = this.props;

    if (onAddDocumentItem && caseIdToConnect) {
      onAddDocumentItem(false, {
        entityType: tableName.connectedCases,
        childId: caseIdToConnect,
        parentEntityPath: [{[tableName.trans]: entityId}, {[tableName.connectionTypes]: connectionTypeId}],
        initialValues: {
          [columnName[tableName.connectedCases].connectedSequence]: [{ value: this.getNextSequenceValue() }] as StoreField[]
        }
      });
    }
  }

  private removeConnection = (caseIdToRemove: number) => () =>  {
    const { entityId, onDeleteDocumentItem, connectionTypeId } = this.props;
    onDeleteDocumentItem && onDeleteDocumentItem(
      false,
      {
        entityType: tableName.connectedCases,
        parentEntityPath: [
          {[tableName.trans]: entityId},
          {[tableName.connectionTypes]: connectionTypeId}
        ],
        childId: caseIdToRemove
      });
  }

  private createFavourite = () => this.props.createSearchForCasesToConnect(this.props.entityId, this.props.connectionTypeId);

  public render() {
    return <EmbeddedFavouriteButton 
              {...this.props}
              renderActionComponent={this.renderActionComponent}
              createFavourite={this.createFavourite}
              />;
  }
}
